
import { WizardStep } from "@/types/enums.type";
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState('Wizard', ['currentStep'])
  }
})
export default class Header extends Vue {
  currentStep!: WizardStep;
  WizardStep = WizardStep;

  get stepCount(): number {
    return Object.keys(WizardStep).length / 2 - 2;
  }
}
